<template>
  <div class="site-wrapper">
    <vue-topprogress
      ref="topProgress"
      :trickleSpeed="150"
      color="#00c1c5"
      show="loading"
    ></vue-topprogress>
    <div
      class="backDrop"
      v-if="this.show"
      data-toggle="collapse"
      data-target="#navbarNavAltMarkup"
      aria-controls="navbarNavAltMarkup"
      aria-expanded="false"
      aria-label="Toggle navigation"
      @click="onBackDropClicked"
    ></div>
    <SideDrawer
      :show="show"
      @sideBarClicked="onSideDrawerClicked"
      @menuCloseClicked="onMenuCloseClicked"
      @codeGarmin="onCodeGarminClicked"
    />

    <div class="a-main a-main--info">
      <div class="a-main__head bg-linear">
        <div class="a-curve">
          <svg
            class="a-curve-svg fill-body"
            viewBox="0 0 366 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M374 0C212.8 76.8 57.5 32 0 0V47.5H374V0Z" />
          </svg>
        </div>
        <div class="container">
          <div class="a-head">
            <div class="a-head__logo-wrap d-flex justify-content-flex-start">
              <button
                class="navbar-toggler navbar-toggler--hamburger"
                type="button"
                @click="onMenuClicked"
                data-toggle="collapse"
                data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup"
                aria-expanded="false"
                aria-label="Toggle navigation"
              ></button>
              <span class="a-head__page align-self-center">
                <span class="a-head__num">05</span>
              </span>
            </div>
            <User v-bind:profile="profile" />
          </div>
        </div>
      </div>
      <div class="a-main__body a-main__body--mt">
        <div class="container">
          <Wellbeing :steps="this.dailies ? this.dailies.steps : 0" />
          <SleepApnea :apneaEvents="totalApneaEvents" />
          <div class="a-block">
            <div class="row">
              <PulseOx :pulse="averageSpo2 ? averageSpo2.toFixed() : 0" />
              <Points />
            </div>
          </div>
          <MedicationDiary />
          <div class="btn btn-pink">
            <svg
              class="a-logo a-logo--btn"
              viewBox="0 0 21 27"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.24275 0.285706C4.11901 0.285706 3.19048 1.21423 3.19048 2.33798V3.25396H2.2745C1.15029 3.25396 0.222229 4.18202 0.222229 5.30623V24.9477C0.222229 26.0719 1.15028 27 2.2745 27H15.9795C17.1037 27 18.0318 26.0719 18.0318 24.9477V24.0317H18.9477C20.0715 24.0317 21 23.1032 21 21.9795V2.33798C21 1.21423 20.0715 0.285706 18.9477 0.285706H5.24275ZM5.24275 1.76983H18.9477C19.275 1.76983 19.5159 2.01077 19.5159 2.33798V21.9795C19.5159 22.3067 19.275 22.5476 18.9477 22.5476H5.24275C4.91554 22.5476 4.67461 22.3067 4.67461 21.9795V2.33798C4.67461 2.01077 4.91554 1.76983 5.24275 1.76983ZM2.2745 4.73809H3.19048V21.9795C3.19048 23.1032 4.11901 24.0317 5.24275 24.0317H16.5476V24.9477C16.5476 25.2745 16.3062 25.5159 15.9795 25.5159H2.2745C1.94777 25.5159 1.70636 25.2745 1.70636 24.9477V5.30623C1.70636 4.97949 1.94776 4.73809 2.2745 4.73809ZM9.86906 7.33531C8.98153 7.33531 8.18118 7.72728 7.66606 8.35565C7.15093 8.98401 6.9008 9.81805 6.9008 10.7094C6.9008 12.0982 7.89394 13.0839 8.87191 13.9791C9.84988 14.8743 10.9154 15.7319 11.4691 16.6227C11.5362 16.728 11.6287 16.8148 11.7381 16.8748C11.8476 16.9349 11.9704 16.9664 12.0952 16.9664C12.2201 16.9664 12.3429 16.9349 12.4524 16.8748C12.5618 16.8148 12.6543 16.728 12.7214 16.6227C13.2751 15.7319 14.3406 14.8743 15.3186 13.9791C16.2966 13.0839 17.2897 12.0982 17.2897 10.7094C17.2897 9.81805 17.0396 8.98401 16.5244 8.35565C16.0093 7.72728 15.209 7.33531 14.3214 7.33531C13.378 7.33531 12.6315 7.73015 12.0952 8.27449C11.559 7.73015 10.8125 7.33531 9.86906 7.33531ZM9.86906 8.81944C10.7395 8.81944 11.2338 9.3362 11.3996 9.80499C11.4523 9.94697 11.5472 10.0694 11.6716 10.1559C11.7959 10.2423 11.9438 10.2887 12.0952 10.2887C12.2467 10.2887 12.3945 10.2423 12.5189 10.1559C12.6433 10.0694 12.7382 9.94697 12.7909 9.80499C12.9567 9.33625 13.451 8.81944 14.3214 8.81944C14.7967 8.81944 15.1193 8.98099 15.3766 9.29482C15.6338 9.60866 15.8056 10.1033 15.8056 10.7094C15.8056 11.321 15.2307 12.0463 14.3098 12.8892C13.6023 13.5369 12.796 14.2593 12.0952 15.0922C11.3945 14.2593 10.5882 13.5369 9.88065 12.8892C8.95981 12.0463 8.38493 11.321 8.38493 10.7094C8.38493 10.1033 8.55666 9.60866 8.81394 9.29482C9.07121 8.98099 9.3938 8.81944 9.86906 8.81944Z"
              />
            </svg>
            <router-link class="btn-link" :to="{ path: 'add-card' }">
              Add a Health Card
            </router-link>
          </div>
          <Exercise />
          <FruitOfTheDay />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { calendarDateFormat, garminPromptMixin } from "@/mixins/appMixins";
import { mapState, mapActions } from "vuex";
import { vueTopprogress } from "vue-top-progress";
import User from "../components/home/User";
import SideDrawer from "../components/navigation/SideDrawer";
import Wellbeing from "../components/home/WellBeingCard";
import SleepApnea from "../components/home/SleepApneaCard";
import PulseOx from "../components/home/PulseOxCard";
import Points from "../components/home/PointsCard";
import MedicationDiary from "../components/home/MedicationDiaryCard";
import Exercise from "../components/home/Exercise";
import FruitOfTheDay from "../components/home/FruitOfTheDay";
import moment from "moment";
export default {
  mixins: [calendarDateFormat, garminPromptMixin],
  data() {
    return {
      show: false,
    };
  },
  components: {
    vueTopprogress,
    User,
    SideDrawer,
    Wellbeing,
    SleepApnea,
    PulseOx,
    Points,
    MedicationDiary,
    Exercise,
    FruitOfTheDay,
  },
  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("garmin", ["dailies", "sleeps", "pulseOx", "garminStatus", "sleepApneaEvents"]),
    ...mapState(["loading"]),

    averageSpo2: function () {
      if (this.pulseOx.spo2) {
        let total = 0;
        let count = 0;
        this.pulseOx.spo2.map((r) => {
          total = total + r.y;
          count++;
        });
        return total / count;
      }
      return 0;
    },
    totalApneaEvents: function () {
      let total = 0
      if(this.sleepApneaEvents.data){
        this.sleepApneaEvents.data.map((item) => {
          total+= item
        })
      }
      return total
    }
  },

  async mounted() {
     this.setLoading(true);
    await this.checkGarminStatus();
    if (localStorage.getItem("access_token") == null) {
      this.$router.go("/");
    }
    if (this.garminStatus) {
      this.pullDailies();
      this.pullPulseOx(this.getDateMonthYear(moment()));
      this.pullSleepApneaEvents()
      this.setLoading(false)
    } else {
      this.setLoading(false)
      this.promptGarminConnect();
    }
  },
  methods: {
    ...mapActions("garmin", [
      "pullDailies",
      "pullPulseOx",
      "pullSleepApneaEvents",
      "checkGarminStatus",
    ]),
    ...mapActions(["setLoading"]),

    onMenuClicked() {
      document
        .getElementsByTagName("body")[0]
        .classList.add("is-off-canvas-open");
      this.show = true;
    },
    onBackDropClicked() {
      this.show = false;
    },
    onMenuCloseClicked() {
      document
        .getElementsByTagName("body")[0]
        .classList.remove("is-off-canvas-open");

      this.show = false;
    },
    onSideDrawerClicked() {
      this.show = false;
    },

    async onCodeGarminClicked() {
      this.$router.push({ name: "TestData" });
    },
  },
};
</script>
<style scoped>
.backDrop {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
